export default __webpack_public_path__ + "static/1655-d0185cade8ca898f0dfcb69f0f6d46dc.gif";